import Repository from '../Repository';

const url = '/blog';

export default {
    getBlogPosts(page = 1) {
        return Repository.get(`${url}/posts?page=${page}`, {localLoading: true});
    },
    getPostBySlug(slug) {
        return Repository.get(`${url}/posts/${slug}`, {localLoading: true});
    }

}
